<template>
  <div class="bottom_nume_left">
    <div class="roomnav">
      <nuxt-link :to="`/room/${roomId}`" :class="{active: t === 'main'}">
        观点
      </nuxt-link>
      <nuxt-link :to="`/room/${roomId}?t=encrypted-view`" :class="{active: t === 'encrypted-view'}">
        加密观点
        <span v-show="!isRoomTeacher && !isRoomGuest && encryptedViewCount">[<i>{{ encryptedViewCount }}</i>]</span>
      </nuxt-link>
      <nuxt-link :to="`/article/list/${teacherId}`">
        文章
        <img v-show="!isRoomTeacher && !isRoomGuest && articleCount" src="~assets/order-icon.png" alt="文章" />
      </nuxt-link>
      <nuxt-link :to="`/vip/detail/${teacherId}`" v-if="trainingId">
        特训班
        <img v-show="!isRoomTeacher && !isRoomGuest && vipCount" src="~assets/order-icon.png" alt="特训班" />
      </nuxt-link>
      <a href="#" @click.prevent="showTip" v-else>特训班</a>
      <nuxt-link :to="`/question/list/${teacherId}`">
        问答
        <span v-show="isRoomTeacher && questionCount > 0">[<i>{{ questionCount }}未答</i>]</span>
      </nuxt-link>
    </div>
    <a class="sound" @click="setSound"><i class="iconfont" :class="isQuite ? 'icon-shengyinkai' : 'icon-shengyinguan'"></i></a>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { playAudio } from '@/utils/Misc'
import Dialog from '@/utils/Dialog'

export default {
  name:'component-room-bottom-nav',
  data () {
    return {
      isQuite: false
    }
  },
  mounted () {
    this.isQuite = !!this.$cookies.get('yf_sound_' + this.roomId)
  },
  methods: {
    setSound () {
      this.isQuite = !this.isQuite

      if (!this.isQuite) {
        this.$cookies.set('yf_sound_' + this.roomId,'',-1, '/')
      } else {
        this.$cookies.set('yf_sound_' + this.roomId, 1, 2000)
        playAudio('yf_sound_' + this.roomId)
      }
    },
    showTip () {
      if (this.isRoomTeacher) {
        Dialog.alert('您尚未创建特训班，是否前去创建？', {
          showCancelButton: true
        }).then(() => {
          this.$router.push('/vip/edit')
        })
      } else {
        Dialog.alert('老师尚未创建特训班')
      }
    }
  },
  computed: {
    t () {
      return this.$route.query.t || 'main'
    },
    ...mapState({
      roomId: state => state.teacher.data.roomId,
      teacherId: state => state.teacher.data.id,
      articleCount: state => state.teacher.saleArticle.length,
      vipCount: state => !!state.teacher.saleVip,
      questionCount: state => state.user.ask.wait,
      trainingId: state => state.teacher.data.trainingId
    }),
    ...mapGetters({
      isRoomTeacher: 'room/isTeacher',
      isRoomGuest: 'room/isGuest'
    }),
    encryptedViewCount () {
      // 如果观点下架，则未购买的用户展示界面不计算该观点条数
      let list = this.$store.state.room.encryptedViewList
      let _list = list.filter(_ => _.content)
      if (list.length === _list.length) {
        return list.length
      } else {
        return list.filter(_ => _.status === 0).length
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bottom_nume_left { position: relative; background: #f7f7f7; text-align: center; height: 64px;  line-height: 64px;
    > .roomnav { width: 693px; height: 64px;  font-size: 16px; position: relative; float: left;
        > a {
          font-size: 16px; color: #666; display: block; width: 138px; border-bottom: 4px solid #f7f7f7; height: 64px; cursor: pointer; float: left;
          &:hover {color: #e03a3c;}
          > span {
            > i  {  color: #e3384a;font-size: 14px;}
          }
        }
    }
    .sound {
      padding: 5px 23px; padding-right: 23px; height: 64px; display: block; cursor: pointer; border-bottom: 4px solid #f7f7f7; line-height: 54px;
      i {
        font-weight: 700; width: 20px; height: 20px; color: #e7383f; font-size: 20px;
      }
    }
}
.active { border-color:#e03a3c!important; color: #e03a3c!important; }
</style>
